import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const UspsShipCarrierInput = groupInput({
  clientId: input<string>({ validator: nonEmptyValidator }),
  clientSecret: input<string>({ validator: nonEmptyValidator }),
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  customerRegistrationId: input<string>({ validator: nonEmptyValidator }),
  mailerId: input<string>({ validator: nonEmptyValidator }),
  manifestId: input<string>({ validator: nonEmptyValidator }),
});

export type UspsShipCarrierValue = InputSchema.Value<
  typeof UspsShipCarrierInput
>;

export type UspsShipCarrierForm = InputSchema.Input<
  typeof UspsShipCarrierInput
>;

export const uspsShipCarrierDefault = (): UspsShipCarrierValue => ({
  clientId: "",
  clientSecret: "",
  accountNumber: "",
  customerRegistrationId: "",
  mailerId: "",
  manifestId: "",
});

export const CreateUspsShipCarrierForm = memo(
  function CreateUspsShipCarrierForm({
    carrierInput,
  }: {
    carrierInput: UspsShipCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          label="Client ID"
          placeholder="Enter client ID"
          setValue={carrierInput.inputs.clientId.setValue}
          value={carrierInput.inputs.clientId.value}
        />
        <RedoTextInput
          label="Client Secret"
          placeholder="Enter client secret"
          setValue={carrierInput.inputs.clientSecret.setValue}
          value={carrierInput.inputs.clientSecret.value}
        />
        <RedoTextInput
          label="Account Number"
          placeholder="Enter account number"
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="Customer Registration ID"
          placeholder="Enter customer registration ID"
          setValue={carrierInput.inputs.customerRegistrationId.setValue}
          value={carrierInput.inputs.customerRegistrationId.value}
        />
        <RedoTextInput
          label="Mailer ID"
          placeholder="Enter mailer ID"
          setValue={carrierInput.inputs.mailerId.setValue}
          value={carrierInput.inputs.mailerId.value}
        />
        <RedoTextInput
          label="Manifest ID"
          placeholder="Enter manifest ID"
          setValue={carrierInput.inputs.manifestId.setValue}
          value={carrierInput.inputs.manifestId.value}
        />
      </>
    );
  },
);
